import React, { useState } from "react";
import prepaid from "../assets/svgs/prepaid.svg";
import packageIcon from "../assets/svgs/package.svg";
import history from "../assets/svgs/history.svg";
import registration from "../assets/svgs/registration.svg";
import snack from "../assets/svgs/snack.svg";
import dealer from "../assets/svgs/dealer.svg"
import referal_Customers from "../assets/svgs/referal_Customers.svg"
import downline from "../assets/svgs/downline.svg"
import cashback from "../assets/svgs/cashback.svg";
import exit from "../assets/svgs/exit.svg";
import referral from "../assets/images/referral.png";
import Card from "./Card";
import Session from "../utils/sessionStorage";
import Prompt from "./Prompt";
import { useNavigate } from "react-router-dom";
import WelcomeModal from "./WelcomeModal";
import BvrResultModal from "./BvrResultModal";
import useBvrBridge from "../hooks/useBvrBridge";

const data = [
  // {
  //   id: 1,
  //   icon: prepaid,
  //   name: "Prepaid",
  //   color: "#F3FAED",
  //   href: "/topup",
  // },
  {
    id: 2,
    icon: packageIcon,
    name: "New Plan",
    color: "#FFF7ED",
    href: "/plan",
  },
  // {
  //   id: 3,
  //   icon: history,
  //   name: "History",
  //   color: "#E5EDF7",
  //   href: "/history",
  // },
  // {
  //   id: 4,
  //   icon: snack,
  //   name: "Food Order",
  //   color: "#FFF8EC",
  //   href: "/order",
  // },
  // {
  //   id: 5,
  //   icon: registration,
  //   name: "Self Register",
  //   color: "#FAEAEA",
  //   href: "/selfregister",
  // },
  {
    id: 6,
    icon: dealer,
    name: "As a Smart Partner",
    color: "#ECF4FF",
    href: "/dealer",
  },
  {
    id: 7,
    icon: referal_Customers,
    name: "Referral Customers",
    color: "#FFF7ED",
    href: "/registered-customers",
  },
  // {
  //   id: 8,
  //   icon: registration,
  //   name: "MNP",
  //   color: "#F3FAED",
  //   href: "/mnp",
  // },
  {
    id: 9,
    icon: cashback,
    name: "CashBack History",
    color: "#E5EDF7",
    href: "/cashback-history",
  },
  {
    id: 10,
    icon: downline,
    name: "Referral List",
    color: "#FFF7ED",
    href: "/referral-list",
  },
  // {
  //   id: 11,
  //   icon: exit,
  //   name: "Exit",
  //   color: "#E5EDF7",
  //   href: "/exit",
  // },
];

const Cards = () => {
  const [linksData, setLinksData] = useState(data);
  const result = Session.get("_user_");
  const userData = result ? JSON.parse(result) : "";
  const navigate = useNavigate();
  const [isPromptModalShows, setIsPromptModalShows] = useState(false);
  const [isWelcomeModalShows, setIsWelcomeModalShows] = useState(false);
  const bvr = useBvrBridge();
  const saOrgName = userData?.saOrgName;

  // useEffect(() => {
  //   // Update state to add `disable` key conditionally
  //   const updatedLinks = data.map((item) => ({
  //     ...item,
  //     disable: true,
  //   }));
  //   setLinksData(updatedLinks);
  // }, []);

  const handleNavigate = (url, data) => {
    if (data.name === "As a Smart Partner" ) {
      if (userData?.customerType === "StdCDD" || userData?.customerType === "FullCDD") {
        setIsWelcomeModalShows(true);
      } else {
        setIsPromptModalShows(true);
      }
    } else if ((userData?.customerType === "NoCDD" && data.name === "As a Dealer")) {
      setIsPromptModalShows(true);
    } else if (data.name === "Exit") {
      Session.clear();
      window.location.href = `https://uat.onepay.com.my/dl/${saOrgName}/?OpName=Close`;
    } else {
      navigate(url);
    }
  };

  const handleCloseModal = () => {
    setIsPromptModalShows(false);
  };

  const handleCloseWelcomeModal = () => {
    if (bvr.pending) return;
    setIsWelcomeModalShows(false);
  };

  const handleProceed = () => {
    bvr.start();
  };

  const handleBvrResultClose = () => {
    const response = bvr.result;
    bvr.clearResult();

    if (response?.success === true) {
      setIsWelcomeModalShows(false);
      navigate("/dealer-register", { state: { sdkResponse: response } });
    }
  };

  return (
    <>
      <div className="grid grid-cols-4 gap-[15px]">
        {linksData?.map((result) => {
          return (
            <Card
              key={result.id}
              data={result}
              handleNavigate={() => handleNavigate(result?.href, result)}
            />
          );
        })}
      </div>

      {isPromptModalShows && (
        <Prompt call={"onLink"} close={handleCloseModal} />
      )}

      <WelcomeModal
        isOpen={isWelcomeModalShows && !bvr.result}
        onClose={handleCloseWelcomeModal}
        onProceed={handleProceed}
        message="Please make sure you have S4S blank sim before proceed"
        cancelText="No"
        proceedText={bvr.pending ? "Processing..." : "Proceed"}
        proceedDisabled={!bvr.ready}
        busy={bvr.pending}
        reference={bvr.reference}
        statusMessage={!bvr.ready
          ? "Open this page in the app to continue. Waiting for the app connection."
          : bvr.error || (bvr.result?.success === false
            ? bvr.result.message || "Verification unsuccessful. Please try again."
            : "")}
      />
      <BvrResultModal
        result={bvr.result}
        reference={bvr.reference}
        onClose={handleBvrResultClose}
      />
    </>
  );
};

export default Cards;
